import { render, staticRenderFns } from "./recruit_need.vue?vue&type=template&id=6178819e&scoped=true"
import script from "./recruit_need.vue?vue&type=script&lang=js"
export * from "./recruit_need.vue?vue&type=script&lang=js"
import style0 from "./recruit_need.vue?vue&type=style&index=0&id=6178819e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6178819e",
  null
  
)

export default component.exports